<template>
    <div class="field-container-2">
        <div class="text-long-header">
            {{header}}
        </div>
        <vue-editor :editorToolbar="defaultToolbarOptions"
                    @input="inputHandler"
                    v-model="value">
        </vue-editor>
        <div v-if="this.validationText !== ''"
             class="hint-text custom-validation-error-text">
            {{this.validationText}}
        </div>
        <div class="hint-text" v-else>{{description}}</div>
    </div>

</template>

<script>
    import {
        EVENT_INPUT,
        EVENT_TOUCHED,
        EVENT_VALIDATION_STATE,
        DEFAULT_LOCALE,
        GET_LOCALE_DISPLAY_NAME,
    } from '../../services/constants'

    import helpers from '../../services/helpers'

    export default {
        name: 'sfr-text-long-field',
        props: ['field', 'valid', 'inputValue'],
        model: {
            prop: 'inputValue',
            event: EVENT_INPUT
        },
        data: function () {
            return {
                isRequired: this.field.required,
                defaultToolbarOptions: [ // list of options: https://github.com/davidroyer/vue2-editor/issues/36
                    ['bold', 'italic', 'underline'],
                    [{'list': 'ordered'}, {'list': 'bullet'}],
                    // ['image', 'code-block']
                ],
                value: this.inputValue ? this.inputValue : '',
                validationText: '',
                inputHandlerCalled: false,
            }
        },
        computed: {
            header: function () {
                return this.computeFieldHeader(this.field)
            },
            isValid: function () {
                return this.valid
            },
            validationRules: function () {
                return [
                    this.isRequired ? v => !!v || `${this.field.name} is required` : () => true,
                ]
            },
            isEditMode: function () {
                return helpers.isEditRoute(this.$route)
            },
            description: function () {
                const currentLocale = this.$store.state.locale.currentLocale
                return currentLocale === DEFAULT_LOCALE ? this.field.description : `${this.field.description} (${this.$store.getters[GET_LOCALE_DISPLAY_NAME](currentLocale)})`
            },
        },
        methods: {
            computeFieldHeader: function (field) {
                return `${field.name}${field.required ? '* ' : ''}:`
            },
            emitInput: function ($event) {
                this.$emit(EVENT_INPUT, $event)
                this.$emit(EVENT_TOUCHED, true)
            },
            inputHandler: function ($event) {
                if (this.inputHandlerCalled) {
                    this.emitInput($event)
                    this.validate()
                } else {
                    this.$emit(EVENT_TOUCHED, true)
                    this.inputHandlerCalled = true
                }
            },
            validate: function () {
                const validationResult = !this.validationRules.map(ruleFunc => {
                    const ruleResult = ruleFunc(this.value)
                    if (ruleResult !== true) {
                        this.validationText = ruleResult
                    } else {
                        this.validationText = ''
                    }
                    return ruleResult === true
                }).some(validationResult => {
                    return validationResult === false
                })
                if (validationResult !== this.isValid) {
                    this.emitValidationState(validationResult)
                }
            },

            emitValidationState: function ($event) {
                this.$emit(EVENT_VALIDATION_STATE, $event)
            },
        },
        created: function () {
            if (this.isEditMode || !this.isRequired) {
                this.validate()
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../../meta";

    .field-container-1 {
        margin: 2em 0;
        .field-container-2 {
            padding: 0 1em;
            $border-width: 3px;
            border-left: $border-width solid $accent;
            border-radius: $border-width;
        }
    }

    .text-long-header {
        font-size: 14px;
        margin: 0 0 1em 0;
    }

    .hint-text {
        color: rgba(0, 0, 0, 0.54);
        font-size: 12px;

        &.custom-validation-error-text {
            color: $error
        }
    }


</style>
